import { Component } from '@angular/core';
import {Events, IonicPage, ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {ApiProvider} from "../../providers/api/api";
import * as moment from "moment";
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";

/**
 * Generated class for the AppWeightUpdateGoalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-weight-update-goal',
  templateUrl: 'app-weight-update-goal.html',
})
export class AppWeightUpdateGoalPage {

  selectedGoalValue:number;
  currentValue:number;
  selectedGoalComment:string;
  errorVisible: boolean;
  hasInitValue: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private stats: UserStatsProvider,
    private progress: UserProgressStateProvider,
    public contentTranslation: ContentTranslationProvider,
    public popoverCtrl: PopoverController,
    private api: ApiProvider,
    private events: Events
  ) {

  }

  ionViewDidLoad() {
    this.currentValue = parseInt(this.navParams.get('currentValue'));
    if (!this.currentValue) {
      this.hasInitValue = false;
    }
  }

  hideError() {
    this.errorVisible = false;
  }

  goNext() {
    if (!this.selectedGoalComment || !this.selectedGoalValue || this.selectedGoalValue > this.currentValue) {
      this.errorVisible = true;
      return;
    }

    let payload  = {
      goalValue: this.selectedGoalValue,
      goalInitValue: this.currentValue,
      goalComment: this.selectedGoalComment,
    };
    if(!this.hasInitValue) {
      (payload as any).currentValue = this.currentValue;
    }

    this.api.callPut('/weights/'+moment().format('YYYYWW'), payload).subscribe((data) => {
      this.events.publish('stats:weight:update', {data})
      this.events.publish('stats:weightGoalUpdated');
      this.navCtrl.pop();
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-weight-update-goal/app-weight-update-goal.ts